/*
* Copyright  2025-2026, Airspan
* All Rights Reserved
*
* This code is unpublished, confidential and proprietary to Airspan and may only be used in accordance with the appropriate
* license agreement. All other copying, modification, distribution, or
* reverse engineering are strictly prohibited.
*/

import LabelConfiguration from "../LabelManagements/LabelConfiguration";

const LabelManagements: React.FC = () => {
  return <LabelConfiguration />;
};

export default LabelManagements;